import type { RoomReclassificationComponentProps } from './RoomReclassificationComponent';

export const RoomReclassificationComponent = {
    MountAsync: async (target: HTMLElement, props: RoomReclassificationComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { RoomReclassificationComponent } = await import('./RoomReclassificationComponent');
        return await mountReactComponentAsync(target, RoomReclassificationComponent, props);
    }
};
